import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { setLastDrawerHeight } from '../store-actions/audit-logs-store-actions';
import AuditLogDrawer from '../components/AuditLogDrawer';
import AuditLogsStore from '../stores/audit-logs-store';

const AuditLogsDrawerContainer: FC<
  React.PropsWithChildren<AuditLogsDrawerContainerProp>
> = ({ className }) => {
  const { selectedAuditLog, lastDrawerHeight } = useSnapshot(AuditLogsStore);

  if (!selectedAuditLog) {
    return null;
  }

  return (
    <AuditLogDrawer
      className={className}
      auditLog={selectedAuditLog}
      defaultHeight={lastDrawerHeight}
      onResizeStop={setLastDrawerHeight}
    />
  );
};

interface AuditLogsDrawerContainerProp {
  className: string;
}

export default AuditLogsDrawerContainer;
